/**
 * @component {"type":"Hotspots","version":"1.2"}
 */

define('component-hotspots',['jquery', 'knockout', 'helpers', 'utils', 'training', 'user-answers', 'qTip'], function($, ko, helpers, utils, Training, UserAnswers) {
    'use strict';

    var setHeight = false;

    return function(parentVM, dataContext) {

        var self		    	= this,
            entityVM            = parentVM.entity,
            // tvm                 = parentVM.training,
            trainingVM          = parentVM.training,
            layoutVM            = parentVM.layout,
            component           = null,
            componentContent    = null,
            classes             = "hs-tooltip qtip-shadow",
            smallBreakPoint     = 768,
            tooltipMargin       = 30,
            tTMinWidth          = 100,
            tTMaxWidth          = 300,
            tTMaxWidthWithImage = 450,
            tTCharsPerRow       = 24,
            training = new Training(),
            userAnswers = new UserAnswers();

        self.exists             = ko.observable(false);
        self.imageSrc           = ko.observable('');
        self.imageUrl           = ko.computed(function() {
                                    return 'url(' + self.imageSrc() + ')';
                                });
        self.spots              = ko.observableArray([]);

        if (!dataContext.learning || !dataContext.learning.current) {
            return;
        }

        self.content = ko.computed(function() {
            var ID = entityVM.ID(),
                entity = training.getContent(ID);

            return {
                ID: ID,
                hotspots: helpers.component.getContent(entity.componentsJSON, 'Hotspots')
            };
        });

        self.interaction = ko.computed(function() {
            var content = self.content();

            if (userAnswers.isPageVisited(content.ID)) {
                return false;
            }

            return (content.hotspots && content.hotspots.interaction) ? true : false;
        });

        self.isSVG = ko.computed(function() {
            var entityContent = entityVM.entityContent();
            return (entityContent && entityContent.hotspotsImageContentType === 'image/svg+xml') ? true : false;
        });

        self.pageChanged = function(){
            var heightCount = 0,
                setMaxHeight = function() {
                    var maxHeight = 0,
                        container = document.getElementById('js-hotspots-container'),
                        hotspotImage = document.getElementById('js-hotspot-img');

                    if (!hotspotImage) {
                        window.removeEventListener('resize', setMaxHeight);
                        return;
                    }

                    if (!setHeight) {
                        hotspotImage.style.maxHeight = '';
                        return;
                    }

                    if (container) {
                        maxHeight = container.clientHeight;
                        hotspotImage.style.maxHeight = maxHeight + 'px';
                    }

                    if (heightCount < 25) {
                        heightCount++;
                        setTimeout(setMaxHeight, 25);
                    }
                };

            setHeight = false;

            component = trainingVM.getComponentsByKind('Hotspots')[0];

            if(component){
                self.exists(true);
                self.spots.removeAll();
                componentContent = component.content;

                self.imageSrc(trainingVM.parseMediaURL(componentContent.backgroundImage));

                var i = 1;

                if (componentContent && componentContent.items && Array.isArray(componentContent.items)) {

                    componentContent.items.forEach(function (item) {
                        var spot = item.content,
                            src = trainingVM.parseMediaURL(spot.image);

                        if (dataContext.debugMode) {
                            console.log('--------- spot ---------');
                            console.dir(spot);
                        }

                        spot.i = i;
                        spot.textLength = (spot && spot.text) ? spot.text.length : 0;
                        spot.opacity = ko.observable(componentContent.itemOpacity);

                        if (item.areaCaption) {
                            spot.caption = ko.observable(item.areaCaption);
                        }

                        spot.content = ko.computed(function(){
                            var imgClass = (spot.text && spot.text !== '&nbsp;') ? 'hs-tooltip-img' : 'hs-tooltip-img hs-tooltip-img-alt',
                                text = (spot.text && spot.text !== '&nbsp;') ? spot.text : '';

                            if (componentContent.clickAsDefaultTrigger === true) {
                                text += '<span class="hotspot-close"> <svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 16 16"> <rect class="modal-ico-close" x="-1.979" y="6.979" transform="matrix(0.7071 0.7071 -0.7071 0.7071 7.9916 -3.3349)" width="20" height="2"/> <rect class="modal-ico-close" x="-1.979" y="6.98" transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 19.3361 7.9502)" width="20.001" height="2"/> </svg> </span>';
                            }

                            return (src) ? '<img src="'+ src +'" class="' + imgClass + ' hs-tooltip-img-top" />' + text + '<img src="'+ src +'" class="' + imgClass + ' hs-tooltip-img-bottom" />' : text;
                        });

                        spot.opacityActive = (componentContent.itemOpacityWhenActive !== '') ? parseFloat(componentContent.itemOpacityWhenActive) : 1;
                        spot.opacity = (componentContent.itemOpacity !== '') ? parseFloat(componentContent.itemOpacity) : 1;

                        spot.styles = ko.computed(function() {
                            var width = (spot.width) ? spot.width.replace(',', '.') : 0,
                                height = (spot.shape === 'circle') ? 'auto' : (spot.height) ? spot.height.replace(',', '.') : 'auto',
                                top = (spot.topCoord) ? spot.topCoord.replace(',', '.') : 0,
                                right = 'auto',
                                bottom = 'auto',
                                left = (spot.leftCoord) ? spot.leftCoord.replace(',', '.') : 0,
                                opacity = (componentContent.itemOpacity !== '') ? parseFloat(componentContent.itemOpacity) : 1;

                            if (parseFloat(left) + parseFloat(spot.width) > 100) {
                                left = 'auto';
                                right = '0';
                            }

                            if (!spot.height && parseFloat(top) + parseFloat(spot.width) > 100 || spot.height && parseFloat(top) + parseFloat(spot.height) > 100) {
                                top = 'auto';
                                bottom = '0';
                            }

                            return 'top: ' + top + '; right: ' + right + '; bottom: ' + bottom + '; left: ' + left + '; width: ' + width + '; height: ' + height + '; opacity: ' + opacity + ';';
                        });

                        spot.attr = function(str) {
                            return 'hotspot-' + str;
                        };

                        spot.toggleOpacity = function(data, e) {
                            e.target.style.opacity = (e.type === 'mouseover') ? spot.opacityActive : spot.opacity;
                        };

                        spot.interacted = (!self.interaction()).toString();

                        self.spots.push(spot);

                        i++;
                    });

                }

                setTimeout(function() {
                    var winScrollTop = $(window).scrollTop();
                    var winScrollLeft = $(window).scrollLeft();
                    var winWidth = $(window).width();
                    var winHeight = $(window).height();

                    for(var i = 0; i < self.spots().length; i++){
                        var item = self.spots()[i];
                        var spot = $('#hotspot-'+ i);
                        var props = defaultProps(componentContent);

                        var offset = spot.offset();
                        var space = {};
                        space.left = (offset) ? offset.left - winScrollLeft : 0;
                        space.top = (offset) ? offset.top - winScrollTop : 0;
                        space.right = winWidth - space.left - spot.width();
                        space.bottom = winHeight - space.top - spot.height();

                        var direction1, direction2;
                        var highest = 0;
                        $.each(space, function(key, direction) {
                            if (direction > highest){
                                highest = direction;
                                direction1 = key;
                            }
                        });

                        switch(direction1){
                            case 'left':
                                props.position.adjust.x = -5;
                                break;
                            case 'top':
                                props.position.adjust.y = -5;
                                break;
                            case 'right':
                                props.position.adjust.x = 5;
                                break;
                            case 'bottom':
                                props.position.adjust.y = 5;
                                break;
                        }

                        space.hors = Math.max(space.left, space.right);
                        space.vert = Math.max(space.top, space.bottom);

                        if(space.hors > space.vert){
                            // dir 2. vert
                            direction2 = (space.bottom > space.top) ? 'bottom': 'top';
                        }else{
                            // dir 2. hors
                            direction2 = (space.right > space.left) ? 'right': 'left';
                        }

                        var atMain = 'top',
                            atSecond = 'center',
                            myMain = 'bottom',
                            mySecond = 'right';

                        if(winWidth > smallBreakPoint){
                            // not "phone"

                            var dir2SpaceRelation = space[direction2] / space[oppositeDir(direction2)];

                            atMain = direction1;
                            myMain = oppositeDir(direction1);

                            if(dir2SpaceRelation > 1.45){
                                mySecond = oppositeDir(direction2);
                            }else{
                                mySecond = 'center';
                            }

                            var widthSuggestion;
                            if(item.image || item.textLength > 400){
                                widthSuggestion = tTMaxWidthWithImage;

                            }else if(item.textLength < tTCharsPerRow){
                                // ~one row
                                widthSuggestion = Math.max(Math.round((item.textLength / tTCharsPerRow) * (tTMaxWidth - 20)), tTMinWidth);

                            }else{
                                widthSuggestion = tTMaxWidth;
                            }
                            // props.style.width = Math.min((space.hors - tooltipMargin), widthSuggestion);
                            props.style.maxWidth = Math.min((space.hors - tooltipMargin), widthSuggestion);
                        }

                        props.position.my = myMain +' '+ mySecond;
                        props.position.at = atMain +' '+ atSecond;

                        props.content = item.content();

                        if(item.image){
                            props.style.classes += ' hs-tooltip-has-image';
                            // The logic where my and at are set could be enhanced when image or a lot of text.
                            // Also tooltip width should adjust to image size.
                        }

                        // add unique class name based on index
                        props.style.classes +=  (' hs-tooltip-' + i);

                        $('#hotspot-'+ i).qtip(props);
                    }

                    setMaxHeight();
                    window.addEventListener('resize', setMaxHeight, false);

                }, 500);

                setTimeout(function() {
                    var $hotspotContainer = $('#js-hotspots-tooltips'),
                        lastRow = ($hotspotContainer.closest('#js-layout-flex').length) ? true : false,
                        $parentRow = $hotspotContainer.closest('.layout-row');

                    setHeight = (lastRow && ($parentRow.siblings('.layout-row').length !== 0 || $('#js-layout-content > .layout-row').length > 1 || layoutVM.isFixed())) ? true : false;

                    if (utils.getLayout() !== 'js-cols') {
                        setHeight = false;
                    }

                }, 100);

            } else if(self.exists){
                self.exists(false);
                self.imageSrc('');
                self.spots([]);
            }
        };

        ko.computed(function() {
            var ID = entityVM.ID();

            self.pageChanged(ID);
        })

        // called once at the end of trainingVM
        function init() {
            trainingVM.hotspots = this;

            // pageChanged won't otherwise be called on the 1st page
            self.pageChanged();
        }

        function defaultProps(componentContent){
            var props = {
                prerender: true,
                content: {
                    attr: 'data-tooltip'/*,
                    text: function (event, api) {
                        // Retrieve content from custom attribute of the $('.selector') elements.
                        return $(this).attr('data-content');
                    }*/
                },
                position: {
                    viewport: $(window),
                    container: (layoutVM.isFixed()) ? $('#js-layout-content') : $('body'),
                    target: 'mouse',
                    my: 'bottom right',
                    at: 'top center',
                    adjust: {
                        resize: true,
                        method: 'shift shift'
                    },
                    effect: false
                },
                style: {
                    classes: classes,
                    tip: {
                        width: 14,
                        height: 12,
                        offset: 10
                    }
                },
                // effect: {
                //     type: 'fade'
                // },
                events: {},
                show: {
                    delay: 0,
                    // effect: false
                    // effect: function(offset) {

                    //     console.error('lorem');
                    //     console.dir(offset);
                    //     console.dir($(this));

                    //     // $(this).css({
                    //     //     'transform': 'scale(0)',
                    //     //     'transition': 'transform 2s linear'
                    //     // });

                    //     // setTimeout(function() {

                    //     //     $(this).css({
                    //     //         'transform': 'scale(1)'
                    //     //     });
                    //     // }, 3000);

                    //     // console.error('offset');
                    //     // console.dir(offset);

                    //     $(this).slideDown(0); // "this" refers to the tooltip
                    // }
                },
                hide: {
                    // delay: 0,
                    effect: false
                }
            };

            props.events.show = function(e, api) {
                $(api.target).removeAttr('data-interacted');
                trainingVM.updateVisited();
            };

            props.show.event = 'mouseenter click';

            props.hide.event = 'mouseleave unfocus';
            // props.hide.delay = 300;
            props.hide.fixed = true;

            if (componentContent.clickAsDefaultTrigger === true) {
                props.show.solo = true;
                props.show.event = 'click';
                // props.hide.delay = 0;
                props.hide.event = 'click unfocus';

                props.position.target = false;
                props.position.adjust.mouse = false;
                props.style.classes += ' hotspot-clickable';
            }

            return props;
        }

        function oppositeDir(dir){

            switch(dir) {
                case 'left':
                    return 'right';
                case 'top':
                    return 'bottom';
                case 'right':
                    return 'left';
                case 'bottom':
                    return 'top';
            }

            return undefined;
        }

        init($, dataContext.learning);
    }
});

